module.exports = __webpack_public_path__ + "static/img/renwutongbu2.688d8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/renwutongbu2.png
// module id = s9Wv
// module chunks = 24